module.exports = __webpack_public_path__ + "static/media/social.61049360.png";